module.exports = __webpack_public_path__ + "static/media/Dashboard-active.e4878791.svg";